import { render } from "./card-amount.vue?vue&type=template&id=5b04735a&scoped=true"
import script from "./card-amount.vue?vue&type=script&lang=js"
export * from "./card-amount.vue?vue&type=script&lang=js"

import "./card-amount.vue?vue&type=style&index=0&id=5b04735a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b04735a"]])

export default __exports__